import '@fpsm/cxy-tokens/tokens.css';

import { I18nextProvider } from 'react-i18next';
import { useLoaderData } from 'react-router';
import { type MyOCData } from '@cx-web/domain-types/myoc';
import { BetslipProvider } from '@cx-web/feature-betslip/context';
import { FeatureFlagProvider } from '@cx-web/feature-flags/provider';
import { GeolocationProvider } from '@cx-web/feature-geolocation/context';
import { LabelProvider } from '@cx-web/feature-i18n';
import { MyOCUserProvider } from '@cx-web/feature-myoc';
import { RepubProvider } from '@cx-web/feature-repub';
import { SiteConfigProvider } from '@cx-web/feature-site-config';
import { getClientI18n } from '@cx-web/utils/getClientI18n';

import { PlusConfigProvider } from '~/providers/plus-config-context';

import { sendGzScrollMessage } from './gz/scripts';
import Body from './body';
import Head from './head';
import { type loader } from './root-loader';

export { loader } from './root-loader';

function App() {
  const {
    ENV,
    featureToggleDefinitions,
    geolocationInfo,
    labels,
    lng,
    myocData,
    oddsFormat,
    persistedBetslipData,
    repub,
    resources,
    siteConfig,
  } = useLoaderData<typeof loader>();

  const i18n = getClientI18n({ lng, resources });

  return (
    <I18nextProvider i18n={i18n}>
      <html lang={lng}>
        <FeatureFlagProvider featureToggleDefinitions={featureToggleDefinitions}>
          <RepubProvider repub={repub}>
            <PlusConfigProvider>
              <MyOCUserProvider myocData={myocData as MyOCData}>
                <GeolocationProvider countryCode={geolocationInfo.countryCode} state={geolocationInfo.subdivisionCode}>
                  <SiteConfigProvider siteConfig={siteConfig}>
                    <LabelProvider devEnv={ENV.NODE_ENV !== 'production'} labels={labels}>
                      <BetslipProvider
                        bookmakers={siteConfig.bookmakers}
                        countryCode={geolocationInfo.countryCode}
                        onBetslipOpenChange={isOpen => sendGzScrollMessage({ variant: 'betslip', isOpen })}
                        persistedBetslipData={persistedBetslipData}
                        repub={repub}
                        subdivisionCode={geolocationInfo.subdivisionCode}
                        userOddsFormat={oddsFormat}
                      >
                        <Head />
                        <Body />
                      </BetslipProvider>
                    </LabelProvider>
                  </SiteConfigProvider>
                </GeolocationProvider>
              </MyOCUserProvider>
            </PlusConfigProvider>
          </RepubProvider>
        </FeatureFlagProvider>
      </html>
    </I18nextProvider>
  );
}

export default App;
